function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "car");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-3",
  transform: "translate(-36.000000, -165.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "car",
  transform: "translate(36.000000, 165.000000)"
}, React.createElement("path", {
  d: "M17.7168609,1.68850962 C17.4946387,1.06163462 16.8724165,0.615384615 16.1390831,0.615384615 L3.91686092,0.615384615 C3.18352758,0.615384615 2.57241647,1.06163462 2.33908314,1.68850962 L0.027972028,8.05288462 L0.027972028,16.5528846 C0.027972028,17.1372596 0.527972028,17.6153846 1.13908314,17.6153846 L2.25019425,17.6153846 C2.86130536,17.6153846 3.36130536,17.1372596 3.36130536,16.5528846 L3.36130536,15.4903846 L16.6946387,15.4903846 L16.6946387,16.5528846 C16.6946387,17.1372596 17.1946387,17.6153846 17.8057498,17.6153846 L18.9168609,17.6153846 C19.527972,17.6153846 20.027972,17.1372596 20.027972,16.5528846 L20.027972,8.05288462 L17.7168609,1.68850962 Z M3.91686092,12.3028846 C2.99463869,12.3028846 2.25019425,11.5910096 2.25019425,10.7091346 C2.25019425,9.82725962 2.99463869,9.11538462 3.91686092,9.11538462 C4.83908314,9.11538462 5.58352758,9.82725962 5.58352758,10.7091346 C5.58352758,11.5910096 4.83908314,12.3028846 3.91686092,12.3028846 Z M16.1390831,12.3028846 C15.2168609,12.3028846 14.4724165,11.5910096 14.4724165,10.7091346 C14.4724165,9.82725962 15.2168609,9.11538462 16.1390831,9.11538462 C17.0613054,9.11538462 17.8057498,9.82725962 17.8057498,10.7091346 C17.8057498,11.5910096 17.0613054,12.3028846 16.1390831,12.3028846 Z M2.25019425,6.99038462 L3.91686092,2.20913462 L16.1390831,2.20913462 L17.8057498,6.99038462 L2.25019425,6.99038462 Z",
  id: "Shape"
}))));

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.4f6eb41f.svg";
export { ForwardRef as ReactComponent };